import React from 'react';
import utils from '../../utils';
import fetch from '../fetch';
import {Tag, Modal ,message} from 'antd';
import moment from 'moment';

const DataGrid = {
    selections: [],
    refresh: function() {

    }
}

const setRefresh = (callback) => {
    DataGrid.refresh = callback
}


const onSelect = (ids) => {
    DataGrid.selections = ids
}

const getSelection =() => {
    return DataGrid.selections;
}

const columnsArray = [
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {
        key: 'orgName', width: 120,
        label: '所属部门'
    },
    {
        key: 'className', width: 100,
        label: '所属班级'
    },
    {
        key: 'classGrade', width: 100,
        label: '所属年级'
    },
    {
        key: 'objectCode', width: 100,
        label: '学号'
    },
    {
        key: 'objectName', width: 85,
        label: '姓名'
    },
    {
        key: 'yearSystemName', width: 85,
        label: '学制'
    },{
        key: 'schoolYearName', width: 85,
        label: '学年'
    },
    {
        key: 'targetName', width: 120,
        label: '模块名称',
    },
    {
        key: 'integralLimit', width: 90,
        label: '最低积分',
    },
    {
        key: 'auditScore', width: 90,
        label: '现有积分',
    },
    {
        key: 'earlyWarningDesc', width: 90,
        label: '学年预警',render:(value) =>{
            if(value == '预警'){
            return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{'预警'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未预警'}</Tag></span>
            }
        }
    },
    {
        key: 'moduleWarningDesc', width: 90,
        label: '模块预警',render:(value) =>{
            if(value == '预警'){
            return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{'预警'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未预警'}</Tag></span>
            }
        }
    },
    // {
    //     key: 'submitEmployeeName', width: 70,
    //     label: '录入人'
    // },
    {key:'resultState', label: '状态', width: 85, render:(d) => (+d === 1 ? <Tag color='#52c41a'>正式提交</Tag> : (+d === 0 ? <Tag color='#722ed1'>进行中</Tag> : <Tag color='#1890ff'>未开始</Tag>))}, 
    // {
    //     key: 'termName', width: 120,
    //     label: '所属学期'
    // },
    {
        key: 'endYearName',
        label: '结束学年'
    },
    {
        key: 'yearName', width: 120,
        label: '所属学年'
    },
    {key:'createTime', label: '创建时间', width: 120, render: (value)=> value ? moment(new Date(value)).format('YYYY/MM/DD') : ""},
]

const headers = utils.columns([
    {type: 'selection'},
    {key:'$index', label: '序号'},
    {
        key: 'orgName', width: 120,
        label: '所属部门'
    },
    {
        key: 'className', width: 100,
        label: '所属班级'
    },
    {
        key: 'objectCode', width: 100,
        label: '学号'
    },
    {
        key: 'objectName', width: 85,
        label: '姓名'
    },
    {
        key: 'yearSystemName', width: 85,
        label: '学制'
    },{
        key: 'schoolYearName', width: 85,
        label: '学年'
    },
    {
        key: 'targetName', width: 120,
        label: '模块名称',
    },
    {
        key: 'integralLimit', width: 90,
        label: '最低积分',
    },
    {
        key: 'auditScore', width: 90,
        label: '现有积分',
    },
    {
        key: 'earlyWarningDesc', width: 90,
        label: '预警状态',render:(value) =>{
            if(value == '预警'){
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#f50" >{'预警'}</Tag></span>
            }else{
                return  <span style={{textAlign:"center",display:"block"}}><Tag color="#108ee9">{'未预警'}</Tag></span>
            }
        }
    },
    // {
    //     key: 'submitEmployeeName', width: 70,
    //     label: '录入人'
    // },
    {key:'resultState', label: '状态', width: 85, render:(d) => (+d === 1 ? <Tag color='#52c41a'>正式提交</Tag> : (+d === 0 ? <Tag color='#722ed1'>进行中</Tag> : <Tag color='#1890ff'>未开始</Tag>))}, 
    // {
    //     key: 'termName', width: 120,
    //     label: '所属学期'
    // },
    {
        key: 'yearName', width: 120,
        label: '所属学年'
    },
    {key:'createTime', label: '创建时间', width: 120, render: (value)=> value ? moment(new Date(value)).format('YYYY/MM/DD') : ""},
    {type:'action', label: '操作', values: ['submit']}
])

const querySearch = (keywords = {pageNum: 1, pageSize: 100}) => {
    var params = [];
    var newKeyword = {};

    for(var i in keywords) {
        if(i === 'pageSize'){
            params.push(`pageSize=${keywords[i]}`);
        } else if(i === 'pageNum'){
            params.push(`pageNum=${keywords[i]}`);
        } else if(i === 'sort'){
            params.push(`sort=${keywords[i]}`);
        } else {
            newKeyword[i] = keywords[i];
        }
    }
    
    return fetch.post('second/credit/earlywarning/query?'+ params.join('&'), newKeyword)
    .then(response => {
        let extParams = response.payload.meta.extParams;
        let newArray = [] 
        
        for(let i = 0; i < columnsArray.length; i++) {
                newArray.push(columnsArray[i])
            if(i === 7) {
                if(extParams) {
                    if(extParams.options.length > 0){
                        extParams.options.forEach(o => {
                            newArray.push({
                                key: o.name,
                                label: o.value
                            })
                        })
                    }
                }
            }
        }
        return {
            data: response.payload.data,
            meta: response.payload.meta,
            headers: utils.columns(newArray.length > 0 ? newArray :columnsArray)
        };
    })
    .then(res => (Object.assign({
        headers: res.headers,
        result: res.data.dataList || [],
        selects: (res.data.dataList || []).map((d,i) => ({
            value: d.resultId,
            checked: false
        })),
        checked: false,
        meta: res.meta,
        total: res.data.total,
        pageIndex: res.data.pageNum,
        pageSize: res.data.pageSize,
        notify: (res.data.dataList || []).length ? '' : '暂无数据...'
    })));
}

/**
 * @method querySearchById
 * @param {number} id
 * @return {promise}
 */
const querySearchById = (id) => {
    return fetch.post('second/credit/earlywarning/getWarningDetail/'+ id, {})
    .then(response => {
        return response;
    });
}

const buildWarning = (callback, keywords) => {
    Modal.confirm({
        title: '确定生成当前检索条件下的记录预警状态吗？',
        content: '生成后预警状态更新！',
        onOk() {
            return fetch.post('second/credit/earlywarning/setResultWarning', keywords)
            .then(response => {
                if(response.code === 200) {
                    message.success(response.message);
                    callback();
                }
            });
        },
        onCancel() {},
        okText:"确认",
        cancelText:"取消"
    });
}


export default {
    setRefresh,
    onSelect,
    getSelection,
    buildWarning,
    headers,
    querySearch,
    querySearchById,
}